/**
 * extract all modifier + modifier option names for all items in menuItemsDetail
 * extracted names are deduped and put into a set
  @param {object} menuItemsDetail (state.menuItemsDetail.byId)
  @return {object} (key is menu item id (product id), value is set of strings(names))
*/
export const getMenuItemsModifierAndOptionNames = menuItemsDetail =>
  Object.values(menuItemsDetail).reduce(
    (result, item) => ({
      ...result,
      [item.id]: [
        ...new Set([
          ...item.modifier_groups.flatMap(modifier =>
            [
              modifier.name,
              ...modifier.options.map(option => option.name)
            ].filter(name => name)
          )
        ])
      ]
    }),
    {}
  );
